import React from 'react'
import renderChildUIComponents from './metadata-mapper'
import Banner from "./Banner";
import { FlatDomainDataContext, FormBean, IUISplitColumnDef } from '../../datatypes';

const {MDBRow, MDBContainer} = require('mdbreact');

interface SplitColumnProps {
    metadata:IUISplitColumnDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;
}

export default class SplitColumn extends React.Component<SplitColumnProps, {}> {
  render() {
    const metadata = this.props.metadata;
    const {cssClasses } = metadata;
    let className = "baseBody " + (cssClasses ? cssClasses : '');

    // console.debug(`SplitColumn render. children.length=${(metadata.children||[]).length}`);
    return (
        <React.Fragment>
            <Banner formBean={this.props.formBean}/>
            <MDBContainer role={"main"} fluid className={className}>
                <h1>{metadata.title || ''}</h1>
                <MDBRow>
                    {renderChildUIComponents({...this.props, metadata})}
                </MDBRow>
            </MDBContainer>
        </React.Fragment>
    )
  }
}